import { AttachmentsListField } from 'domain/shared/artifact/field';
import FeedbackField from 'domain/people/employee/assessment/shared/input/FeedbackField';
import { useState } from 'react';
import { CapitalizedField, DateField, FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
import { BigSectionRow, SectionRow, ShowSection } from 'framework/ui/layout';
import { Modal } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';

const AssessmentLevelWithDetailsFields = ({ ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ ...props } as FieldProps);
  const [modalOpen, setModalOpen] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const levelAssignment = getValue();

  return (
    <>
      <Button
        sx={{
          display: 'block',
          textAlign: 'start',
          minWidth: '40px',
          maxWidth: '40px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
        onClick={() => setModalOpen(true)}
        link
      >
        {levelAssignment}
      </Button>

      <Modal backdrop isOpen={modalOpen} title="Assessment details" onToggle={closeModal} hasCancelButton={false}>
        <ShowSection>
          <SectionRow colXl={4}>
            <CapitalizedField label="Assignment language" source="assignmentLanguage" />
            <TextField source="levelAssignment" />
            <DateField source="assessmentDate" />
            <TextField source="assessorName" label="Assessor" />
          </SectionRow>

          <BigSectionRow>
            <FeedbackField source="feedbackDetails" />
          </BigSectionRow>

          <BigSectionRow>
            <AttachmentsListField source="filesIds" label="Document Scans" />
          </BigSectionRow>
        </ShowSection>
      </Modal>
    </>
  );
};

export default AssessmentLevelWithDetailsFields;
